.wrapper {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  height: 56px;
  padding: 0 calc(var(--spacing) * 2);
  border-radius: var(--border-radius);
  background: white;

  &.column {
    flex-direction: column;
    align-items: flex-start;
  }

  &.row {
    flex-direction: row;
  }

  &.clickable {
    cursor: pointer;
    user-select: none;
    & > * {
      pointer-events: none;
    }
  }

  &.flexStart {
    justify-content: flex-start;
  }

  &.alternateBackground {
    background: var(--color-cool-gray);
  }

  &.reverseLayout {
    flex-direction: row-reverse;
    justify-content: left;
  }

  &.isDisabled {
    cursor: default;
    pointer-events: none;

    & > * {
      opacity: 0.5;
      padding-bottom:5px;
      
    }
    &.paddingTopBottom {
      & > * {
        padding-bottom: 0; 
      }
    }
  }

  &.isDisabledVisible {
    cursor: default;
    pointer-events: none;

    & > * {
      opacity: 1;
    }
  }


  &.larger {
    height: 73px; /* NOTE: Allows for an extra info line */
  }

  &.responsive {
    height: auto;
    padding: calc(var(--spacing) * 2);
  }

  &.noPadding {
    padding: 0; 
    height: auto;
  }

  &.paddingTopBottom {
    padding: var(--spacing) 0; 
    height: auto;
  }

  &.hidden {
    display: none;
  }

}
